// Module
var code = "<template> <require from=\"app/core/components/tasks/task\"></require> <task task-binding.bind=\"taskBinding\" task-display.bind=\"taskDisplay\"></task> </template> ";
// Exports
module.exports = code;